import { useState, useRef, useReducer, useEffect } from "react";
import { RichText } from "@wordpress/block-editor";
import ReCAPTCHA from "react-google-recaptcha";

import {
  formReducer,
  processCommunicationForm,
  getSettings,
} from "../civicrm/form-utils";

export const CommunicationBlock = ({
  introText,
  footerText,
  buttonText,
  groupId,
  thankyouURL,
  setAttributes = null,
  isSelected = false,
  mode = "frontend",
}) => {
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [formData, setFormData] = useReducer(formReducer, {});
  const captchaRef = useRef(null);
  const [recaptchaSiteKey, setRecaptchaSiteKey] = useState(null);

  useEffect(() => {
    getSettings()
      .then((data) => {
        setRecaptchaSiteKey(data.recaptchaSiteKey);
      })
      .catch((error) => {
        console.log("Error fetching settings: " + error);
      });
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const reCaptchaToken = await captchaRef.current.executeAsync();
    captchaRef.current.reset();

    setProcessing(true);
    setErrorMessage(null);

    formData["group_id"] = groupId;
    formData["reCaptchaToken"] = reCaptchaToken;

    await processCommunicationForm(formData)
      .then((data) => {
        setProcessing(false);
        if (thankyouURL) {
          window.location.href = thankyouURL;
        } else {
          setSuccessMessage("Your information has been saved successfully!");
          setFormData({ name: "first_name", value: "" });
          setFormData({ name: "last_name", value: "" });
          setFormData({ name: "email", value: "" });
        }
      })
      .catch((error) => {
        setProcessing(false);
        setErrorMessage(error.message);
      });
  };

  const handleChange = (event) => {
    setFormData({
      name: event.target.name,
      value: event.target.value,
    });
  };

  const formFields = (
    <>
      <label htmlFor="first_name">First name</label>
      <input
        type="text"
        required
        name="first_name"
        onChange={handleChange}
        value={formData.first_name || ""}
      />
      <label htmlFor="last_name">Last name</label>
      <input
        type="text"
        required
        name="last_name"
        onChange={handleChange}
        value={formData.last_name || ""}
      />
      <label htmlFor="email">Email</label>
      <input
        type="email"
        required
        name="email"
        onChange={handleChange}
        value={formData.email || ""}
      />
    </>
  );

  let formElement = (
    <>
      <div className="communication-block">
        {processing ? <div>Processing...</div> : null}
        {successMessage ? (
          <div className="success-message">{successMessage}</div>
        ) : null}
        {introText || isSelected ? (
          <>
            {mode === "preview" ? (
              <RichText
                tagName="p"
                value={introText}
                allowedFormats={["core/bold", "core/link"]}
                onChange={(introText) => setAttributes({ introText })}
                placeholder={"Intro text"}
              />
            ) : (
              <p dangerouslySetInnerHTML={{ __html: introText }} />
            )}
          </>
        ) : (
          ""
        )}

        {formFields}

        {footerText || isSelected ? (
          <>
            {mode === "preview" ? (
              <RichText
                tagName="p"
                value={footerText}
                allowedFormats={["core/bold", "core/link"]}
                onChange={(footerText) => setAttributes({ footerText })}
                placeholder={"Footer text"}
              />
            ) : (
              <p
                className="footer-text"
                dangerouslySetInnerHTML={{ __html: footerText }}
              />
            )}
          </>
        ) : (
          ""
        )}

        {errorMessage ? (
          <div className="error-message">{errorMessage}</div>
        ) : null}

        {mode === "preview" ? (
          <button>
            <RichText
              tagName="span"
              value={buttonText}
              allowedFormats={[]}
              onChange={(buttonText) => setAttributes({ buttonText })}
              onReplace={() => {}}
              onSplit={() => {}}
              placeholder={"Button text"}
            />
          </button>
        ) : (
          <button type="submit" disabled={processing}>
            {buttonText}
          </button>
        )}
      </div>
      {recaptchaSiteKey ? (
        <ReCAPTCHA
          sitekey={recaptchaSiteKey}
          ref={captchaRef}
          size="invisible"
        />
      ) : (
        ""
      )}
    </>
  );

  // add form element only for the frontend and enabled processing
  if (mode === "frontend") {
    formElement = <form onSubmit={handleSubmit}>{formElement}</form>;
  }

  return formElement;
};
